import { ThemeColors } from 'hooks/useTheme';

export const buildThemeParams = (theme: ThemeColors): string => {
  const params = new URLSearchParams();

  // Passe as cores diretamente, sem replace
  params.append('bg_primary', theme.background.primary);
  params.append('bg_secondary', theme.background.secondary);
  params.append('primary', theme.primary);
  params.append('text_primary', theme.text.primary);
  params.append('text_secondary', theme.text.secondary);

  // Adiciona as cores fixas também
  params.append('success', theme.success);
  params.append('warning', theme.warning);
  params.append('info', theme.info);
  params.append('error', theme.error);

  return params.toString();
};
